import React from 'react';
import { Icon } from 'antd';

class App extends React.Component {
  
  render() {
    return (
      <div className="ecode-dev-empty">
        <Icon type="warning" />
        无权限
      </div>
    )

  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/dev/EcodeEmpty.js